import React from 'react';
import styled from 'styled-components';

import theme from '../styled/theme';
import PriceTag from '../PriceTag';

const Wrapper = styled.div`
  border: 5px dotted ${theme.colors.grayDark};
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: ${props => (props.groovy ? 'Chunq' : 'Oneer')};
  background: ${props => props.bgColor || 'transparent'};
  text-align: center;
  margin: 1rem 0;
  padding: 0.5rem;

  h2 {
    font-size: ${props => props.titleSize || (props.small ? '35px' : '60px')};
    color: ${props => props.textColor || props.color || theme.colors.grayDark};
    font-weight: ${props => props.fontWeight || '900'};
    line-height: 0.75;
    margin: 0;
    position: relative;
    text-transform: uppercase;

    small {
      bottom: 10px;
      font-size: 0.5em;
      position: absolute;
      margin-left: 10px;
    }

    @media (max-width: 767px) {
      font-size: ${props => props.titleSizeMobile || (props.small ? '24px' : '36px')};
    }
  }

  div {
    display: flex;
  }
`;

const Description = styled.h5`
  font-family: Arial, Helvetica;
  font-size: ${props => props.descriptionSize || '1rem'};
  color: ${props => props.descriptionColor || '#84807c'};
  text-transform: uppercase;
  margin: 0;
  text-align: ${props => props.descriptionAlign || 'center'};

  @media (max-width: 767px) {
    font-size: ${props => props.descriptionSizeMobile || '0.9rem'};
  }
`;

const SectionHead = props => (
  <>
    <Wrapper
      small={props.small}
      color={props.color}
      textColor={props.textColor}
      fontWeight={props.fontWeight}
      bgColor={props.bgColor}
      groovy={props.groovy}
      titleSize={props.titleSize}
      titleSizeMobile={props.titleSizeMobile}
    >
      <div>
        {props.price && (
          <PriceTag
            price={props.price}
            color={props.color}
            textColor={props.textColor}
            fontWeight={props.fontWeight}
          />
        )}
        <h2>
          {props.children}
          {props.subtitle && <small>{props.subtitle}</small>}
        </h2>
      </div>
      {props.description && !props.descriptionOutside && (
        <Description
          descriptionSize={props.descriptionSize}
          descriptionSizeMobile={props.descriptionSizeMobile}
          descriptionColor={props.descriptionColor}
          descriptionAlign={props.descriptionAlign}
        >
          {props.description}
        </Description>
      )}
    </Wrapper>
    {props.description && props.descriptionOutside && (
      <Description
        descriptionSize={props.descriptionSize}
        descriptionSizeMobile={props.descriptionSizeMobile}
        descriptionColor={props.descriptionColor}
        descriptionAlign={props.descriptionAlign}
      >
        {props.description}
      </Description>
    )}
  </>
);

export default SectionHead;
